export default function Meter({
  used,
  total,
  unit = "GB",
  warnPct = 85,
  dangerPct = 95,
}: {
  used: number;
  total: number;
  unit?: string;
  warnPct?: number;
  dangerPct?: number;
}) {
  const pct = total > 0 ? Math.min(100, (used / total) * 100) : 0;
  const cls = pct >= dangerPct ? "danger" : pct >= warnPct ? "warn" : "";
  return (
    <div style={{ minWidth: 140 }}>
      <div className={`bar ${cls}`}>
        <span style={{ width: `${pct}%` }} />
      </div>
      <div className="muted" style={{ fontSize: 12, marginTop: 3 }}>
        {used.toFixed(1)} / {total.toFixed(1)} {unit} ({pct.toFixed(0)}%)
      </div>
    </div>
  );
}
